/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Palette_SearchingInputs */

const en_palette_searching = /** @type {(inputs: Palette_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching…`)
};

/**
* | output |
* | --- |
* | "Searching…" |
*
* @param {Palette_SearchingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const palette_searching = /** @type {((inputs?: Palette_SearchingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Palette_SearchingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_palette_searching(inputs)
});